export class Address {
  street: string = "";
  houseNumber: string = "";
  additionalAddressLine: string = "";
  zip: string = "";
  city: string = "";
}
